import { useBoolean } from 'app/shared/hooks/useBoolean';

export function useToggle(initialState: boolean) {
  const [value, { toggle }] = useBoolean(initialState);

  return [value, toggle] as [typeof value, typeof toggle];
}
